import { Reveal } from "@/components/site/Reveal";
import { PageHero, SectionLabel, EnquiryBanner, PrimaryLink } from "@/components/site/Sections";
import { CheckCircle2 } from "lucide-react";
import { PRODUCTS, PRODUCT_SEGMENTS, CONTACT } from "@/lib/data";

const Products = () => (
  <div data-testid="products-page">
    <PageHero
      label="Products"
      title="Paper & board, sourced with confidence."
      subtitle="From everyday printing paper to specialty grades — a portfolio built for printers, publishers, packaging companies and trade buyers."
    />

    <section className="relative z-10 pb-24 lg:pb-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {PRODUCT_SEGMENTS.map((seg, si) => (
          <div key={seg.id} className={si === 0 ? "" : "mt-28 lg:mt-36"}>
            <Reveal className="mb-16 lg:mb-20 max-w-3xl">
              <SectionLabel>{`Segment 0${si + 1}`}</SectionLabel>
              <h2 className="mt-5 font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-forest leading-tight">{seg.title}</h2>
              <p className="mt-4 text-lg text-ink-soft leading-relaxed">{seg.note}</p>
            </Reveal>

            <div className="space-y-24 lg:space-y-32">
              {PRODUCTS.filter((p) => p.segment === seg.id).map((p) => {
                const i = PRODUCTS.findIndex((x) => x.slug === p.slug);
                return (
                  <div
                    key={p.slug}
                    id={p.slug}
                    data-testid={`product-section-${p.slug}`}
                    className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center scroll-mt-32"
                  >
                    <div className={`lg:col-span-6 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
                      <Reveal className="overflow-hidden rounded-sm group">
                        <img src={p.image} alt={`${p.name} — ${p.tag}`} className="w-full h-[380px] lg:h-[520px] object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
                      </Reveal>
                    </div>
                    <div className={`lg:col-span-6 ${i % 2 === 1 ? "lg:order-1" : ""}`}>
                      <Reveal><SectionLabel>{p.tag}</SectionLabel></Reveal>
                      <Reveal delay={0.08}>
                        <h3 className="mt-5 font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-forest">{p.name}</h3>
                      </Reveal>
                      <Reveal delay={0.14}>
                        <p className="mt-6 text-lg text-ink-soft leading-relaxed">{p.short}</p>
                      </Reveal>
                      <Reveal delay={0.2}>
                        <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.24em] text-gold">Typical applications</p>
                        <ul className="mt-4 grid sm:grid-cols-2 gap-2.5">
                          {p.applications.map((a) => (
                            <li key={a} className="flex items-center gap-2.5 text-ink-soft">
                              <CheckCircle2 className="h-4 w-4 text-forest shrink-0" /> {a}
                            </li>
                          ))}
                        </ul>
                      </Reveal>
                      <Reveal delay={0.26}>
                        <div className="mt-6 space-y-3 border-l-2 border-paper-border pl-5">
                          <p className="text-sm text-ink-soft leading-relaxed"><span className="text-forest font-medium">Buyer relevance — </span>{p.relevance}</p>
                          <p className="text-sm text-ink-soft leading-relaxed"><span className="text-forest font-medium">Sourcing strength — </span>{p.sourcing}</p>
                        </div>
                      </Reveal>
                      <Reveal delay={0.32}>
                        <div className="mt-8">
                          <PrimaryLink
                            href={`${CONTACT.whatsapp.split("?")[0]}?text=${encodeURIComponent(`Hello Mysore Paper, I'd like to enquire about ${p.name}.`)}`}
                            testId={`product-enquiry-${p.slug}`}
                          >
                            Request Specs &amp; Pricing
                          </PrimaryLink>
                        </div>
                      </Reveal>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </section>

    <EnquiryBanner />
  </div>
);

export default Products;
